// Duck (bonus): taken when a ball touches it. S.duckGot / simulate().duck
import { defineObj } from '../core/registry';
import { shadowOn, shadowOff, C } from '../core/draw-helpers';
import type { Ctx2D, GameBody } from '../core/types';

export interface Duck { x: number; y: number; body: GameBody }
declare module '../core/types' { interface SimState { duck: Duck | null } }

export function drawDuck(ctx: Ctx2D, x: number, y: number, t: number, got: boolean) {
  if (got) return;
  ctx.save(); ctx.translate(x, y + Math.sin(t * 0.08) * 3);
  ctx.globalAlpha = 0.95;
  shadowOn(ctx, 8, 4);
  ctx.beginPath(); ctx.ellipse(0, 6, 17, 11, 0, 0, 7); ctx.fillStyle = '#FFD93B'; ctx.fill(); shadowOff(ctx);
  ctx.beginPath(); ctx.arc(-6, -6, 10, 0, 7); ctx.fillStyle = '#FFD93B'; ctx.fill();
  ctx.beginPath(); ctx.moveTo(-15, -6); ctx.lineTo(-24, -3); ctx.lineTo(-15, -1); ctx.fillStyle = '#FF8A3D'; ctx.fill();
  ctx.beginPath(); ctx.arc(-8, -8, 2.3, 0, 7); ctx.fillStyle = C.ink; ctx.fill();
  ctx.beginPath(); ctx.ellipse(6, 4, 7, 4, -0.3, 0, 7); ctx.fillStyle = '#F5B800'; ctx.fill();
  // glint
  const s = (Math.sin(t * 0.1) + 1) / 2;
  ctx.fillStyle = `rgba(255,255,255,${s})`; ctx.beginPath(); ctx.arc(10, -12, 3, 0, 7); ctx.fill();
  ctx.restore();
}

export const duck = defineObj({
  // drawn after the worlds' rearmost objects and not on level pictures
  phase: 'core', layer: 'back', z: 1, thumb: false,
  create(api, o) {
    const b = api.add(api.Bodies.circle(o.x, o.y, 18, { isStatic: true, isSensor: true }));
    b.kind = 'duck';
    const D: Duck = { x: o.x, y: o.y, body: b };
    api.S.duck = D;
    return D;
  },
  draw: (ctx, st, t, g, S) => { if (S.duck === st) drawDuck(ctx, st.x, st.y, t, S.duckGot); },
  fx: { duck: (ev, f) => { f.sfx('duck'); f.burst(ev.x!, ev.y!, '#FFD93B', 16, 3); } },
  system: {
    init: api => { api.S.duck = null; },
    contact: {
      duck(api, x, y) {
        const S = api.S;
        if ((y.kind === 'hero' || y.kind === 'helper') && !S.duckGot) { S.duckGot = true; S.events.push({ e: 'duck', x: x.position.x, y: x.position.y }); }
      },
    },
  },
});
